import { bootstrap } from '../util';

import ApiService from '../../APIService';
import Vue from 'vue';

const moduleData = {
    namespaced: true,
    state: {
        groups: [],
        devices: [],
        dontRefresh: false,
        noConnection: false
    },
    api: null,
    mutations: {
        updateDevice(state, device) {
            let deviceTemp = Object.keys(state.devices).find(key => state.devices[key].id === device.id);
            if (!deviceTemp || deviceTemp < 0) {
                state.devices.push(device);
            } else {
                Vue.set(state.devices, deviceTemp, { ...state.devices[deviceTemp], ...device });
            }
        }
    },
    actions: {
        NEW_API(context, newUrl) {
            localStorage.setItem('api_base_url', newUrl);
            console.log('Set api url to ' + newUrl);
        },
        RESET(context) {
            localStorage.removeItem('api_base_url');
            console.log('Reset api url');
        },
        LOGIN(context, user) {
            if (!this.api) this.api = new ApiService();
            return this.api.login(user);
        },
        GET_DEVICES(context) {
            if (!this.api) this.api = new ApiService();
            return this.api.fetchDevices()
                .then(response => {
                    let groups = [];
                    for (let device of response) {
                        if (groups.indexOf(device.group) < 0 && device.group) groups.push(device.group);
                        device.state = Vue.moment(device.lastTime).isAfter(Vue.moment().subtract(5, 'minutes')) ? 2 : 1;
                        context.commit('updateDevice', device);
                    }
                    groups.sort();
                    context.commit('groups', groups);
                    context.commit('noConnection', false);
                    return response;
                })
                .catch(error => {
                    context.commit('noConnection', true);
                    if (error.response && error.response.data.error === 'Unauthorized') {
                        context.dispatch('logout', null, { root: true });
                    }
                    throw error;
                });
        },
        GET_DEVICE(context, deviceId) {
            if (!this.api) { return }
            return this.api.fetchDevice(deviceId)
                .then(response => {
                    context.commit('updateDevice', response);
                    return response;
                })
                .catch(error => {
                    console.log(error.stack);
                    throw error;
                });
        },
        UPDATE_ALARM(context, alarm) {
            if (!this.api) return;
            context.commit('dontRefresh', 1);
            return this.api.updateAlarm(alarm.alarm, alarm.deviceID)
                .then(response => {
                    context.dispatch('GET_DEVICE', alarm.deviceID).finally(() => {
                        context.commit('dontRefresh', 0);
                    });
                })
                .catch(error => {
                    console.log(error.stack);
                    throw error;
                });
        },
        CLEAN(state) {
            state.state.devices = [];
            state.state.groups = [];
        }
    }
};

export default bootstrap(moduleData);
